<div
  *ngIf="commercialAgreement !== null"
  class="bg-[#E8EDFD] rounded-[12px] px-[18px] py-[12px]"
>
  <!-- Loading State -->
  <div
    *ngIf="
      commercialAgreement.code === null &&
      commercialAgreement.creationErrorDetail === null
    "
    class="flex items-center gap-3"
  >
    <div class="flex flex-col items-center space-y-2">
      <ui-loader type="primary" size="2xl" />
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-900"
        font-weight="regular"
      >
        cargando
      </ui-paragraph>
    </div>
    <div class="flex items-center">
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-900"
        font-weight="semibold"
      >
        Acuerdo de reserva N° xxxxx
      </ui-paragraph>
    </div>
  </div>

  <!-- Success State -->
  <div
    *ngIf="
      commercialAgreement.code !== null &&
      commercialAgreement.creationErrorDetail === null
    "
    class="flex items-center gap-4"
  >
    <ui-icon
      name="warning-critical-outline"
      fill="critical-300"
      m-size="24"
      size="24"
    />
    <div class="flex items-center">
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-900"
        font-weight="semibold"
      >
        Acuerdo de reserva N° {{ commercialAgreement.code }}
      </ui-paragraph>
    </div>
  </div>

  <!-- Error State -->
  <div
    *ngIf="
      commercialAgreement.code === null &&
      commercialAgreement.creationErrorDetail !== null
    "
    class="flex items-center gap-2"
  >
    <ui-icon
      name="warning-critical-filled"
      fill="critical-300"
      m-size="24"
      size="24"
    />
    <div class="flex items-center">
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-900"
        font-weight="semibold"
      >
        {{ commercialAgreement.creationErrorDetail }}
      </ui-paragraph>
    </div>
  </div>
</div>
